export default __webpack_public_path__ + "static/media/Element-6.46430597.png";